import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useIntl } from "react-intl";
import { BackButton, ButtonSubmit, Container, Panel } from "../../../../Components";
import { TextField2 } from "../../../../Components/Field";
import { SelectDropDown } from "../../../../Components/Select/SelectDropDown";
import { useStyles } from "./Document.styles";
import { FileUpload, FileUploadProps } from "./FileUpload";
import { FileTypes } from "./FileTypes";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import { useDispatch, useSelector } from "react-redux";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateDocument } from "../DocumentGroup/DocumentGroup/CreateDocument";
import DocumentGroupServices from "../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import { useSnackbar } from "notistack";
import DropDownItem from "./DropDownItem";
require("./styles.css");
type uploadProps = {
  fileName?: string;
  filePath?: string | number | string[];
  userName?: any;
  urlPath?: any;
  description: string;
  name: string;
};

export const ArchiveUploadDocument = () => {
  const {
    apiToken,
    currentUser,
    uploadData,
    allDocumentsGroup,
    treeStructureDocument,
  } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
    uploadData: state?.CustomerReducer?.uploadData,
    allDocumentsGroup: state?.DocumentGroupReducer?.allDocumentsGroup,
    treeStructureDocument: state?.DocumentGroupReducer?.treeStructureDocument,
  }));
  const { formatMessage } = useIntl();
  let addGroup = [
    {
      id: 0,
      name: formatMessage({
        id: "document.upload.addGroup",
        defaultMessage: "Add group",
      }),
      description: "",
    },
    // {
    //   id: -1,
    //   name: formatMessage({
    //     id: "document.upload.removerDocument",
    //     defaultMessage: "Remove document group",
    //   }),
    //   description: "",
    // },
  ];
  let [select, setSelect] = useState<uploadProps>({
    filePath: "",
    userName: "",
    urlPath: "",
    name: "",
    description: "",
  });
  const [fileName, setFileName] = useState<uploadProps>();
  const [reload, setReload] = useState(false);
  let [selected, setSelected] = useState<any>("");
  const [file, setFile] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [selectValue, setSelectValue] = useState({ id: "", name: "" });
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
  const navigate = useNavigate();
  const users = useLocation().state?.rowData;
  const [allDocumentGroupMarge, setallDocumentGroupMarge] = useState<any>([]);
  let [checked, setChecked] = React.useState(false);
  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };
  // const getMembers = (members) => {
  //   let children: any = [];

  //   return members
  //     .map((mem) => {
  //       const m = { ...mem };
  //       if (m.children && m.children.length) {
  //         children = [...children, ...m.children];
  //       }
  //       delete m.children;
  //       return m;
  //     })
  //     .concat(children.length ? getMembers(children) : children);
  // };
  useEffect(() => {
    // const data = getMembers(allDocumentsGroup);
    // const filterItem =
    //   data?.length && data?.filter((val) => val?.restrictUploads == false);
    setallDocumentGroupMarge([...addGroup, ...allDocumentsGroup]);
  }, [allDocumentsGroup]);
  useEffect(() => {
    hierarchicalDocumentFunction();
    setSelect({
      description: users?.description,
      name: users?.name,
    });
    setFile(users?.url);
    if (users?.documentGroupId != undefined || users?.documentGroupId != null)
      setSelected(users?.documentGroupId);
    setSelectValue({
      id: users?.documentGroupId,
      name: users?.documentGroupName,
    });
  }, []);
  const hierarchicalDocumentFunction = () => {
    let customerId = currentUser?.customerId;
    dispatch(DocumentGroupServices.documentHierarchical(customerId, apiToken));
  };
  const fileUploadProp: FileUploadProps = {
    accept: "file/*",
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target?.files !== null && event.target?.files?.length > 0) {
        setFile(event?.target?.files[0]);
        let value = event?.target?.files[0].name;
        setSelect({ ...select, name: value });
      }

      let fileType = FileTypes;
      let selectFile = event?.target?.files![0];
      setFileName((): any => {
        const initialValue = selectFile?.name;
        return initialValue || "";
      });
      setSelect({ ...select, name: selectFile?.name });
      if (selectFile) {
        if (selectFile && fileType.includes(selectFile?.type)) {
          let reader = new FileReader();
          reader.readAsDataURL(selectFile);
          reader.onloadend = (e) => {
            setSelect({ ...select, name: selectFile?.name });
          };
        }
      } else {
        alert("select file");
      }
    },
    onDrop: (event: React.DragEvent<HTMLElement>) => {
      let fileType = FileTypes;
      let selectFile = event?.dataTransfer?.files![0];
      setFile(event.dataTransfer?.files![0]);
      let value: any = { name: event?.dataTransfer?.files![0].name };
      setSelect(value);
      if (selectFile) {
        if (selectFile && fileType.includes(selectFile?.type)) {
          let reader = new FileReader();
          reader.readAsDataURL(selectFile);
          reader.onloadend = (e) => {
            setSelect({ ...select, name: selectFile?.name });
          };
        }
      } else {
        alert("select file");
      }
    },
  };
  const fileUpload = () => {
    let uploadkey: any = "uploadFile";
    let fileNamekey: any = "fileName";
    let descriptionkey: any = "description";
    if (!file) {
      ErrorMessage(file, uploadkey);
    } else if (!select?.name) {
      ErrorMessage(file, fileNamekey);
    } else if (!select?.description) {
      ErrorMessage(file, descriptionkey);
    } else {
      let formData = {
        File: file,
        Description: select?.description,
        Name: select?.name,
        DocumentGroupId: Number(selected),
      };
      const customerId = currentUser?.customerId;
      dispatch(
        CustomerServicesApi.uploadFile(
          formData,
          customerId,
          apiToken,
          notifySuccess,
          enqueueSnackbar
        )
      );
      setTimeout(() => {
        fileuploadReload();
      }, 1500);
    }
  };
  const updateDocument = () => {
    let uploadkey: any = "uploadFile";
    let fileNamekey: any = "fileName";
    let descriptionkey: any = "description";
    if (!file) {
      ErrorMessage(file, uploadkey);
    } else if (!select?.name) {
      ErrorMessage(file, fileNamekey);
    } else if (!select?.description) {
      ErrorMessage(file, descriptionkey);
    } else {
      let formData;
      formData = {
        File: file,
        Description: select?.description,
        Name: select?.name,
        DocumentGroupId: Number(selected),
      };
      console.log(formData, "formData");
      let documentId = users?.id;
      dispatch(
        CustomerServicesApi.documentUpdateFile(
          formData,
          documentId,
          apiToken,
          enqueueSnackbar
        )
      );
      setTimeout(() => {
        fileuploadReload();
      }, 1500);
    }
  };
  const fileuploadReload = () => {
    const customerId = currentUser?.customerId;
    let isArchive=false
    if (uploadData) {
      navigate("/ms/administrations/archive");
      dispatch(
        CustomerServicesApi.getAllDocuments(
          customerId,
          currentUser?.id,
          apiToken,
          isArchive
        )
      );
    }
  };
  const cancelButton = () => {
    setFile(null);
    const formData = {
      file: "",
      description: "",
      name: "",
    };
    setSelect(formData);
    navigate("/ms/administrations/archive");
  };
  const handleChangeGroup = (event: any) => {
    let selecValue = event?.target?.value;
    if (selecValue == 0) {
      setOpen(true);
    } else {
      setSelect({ ...select, userName: selecValue });
      setSelected(selecValue);
    }
  };

  const closeBox = () => {
    setOpen(false);
  };
  const reloadTable = () => {
    dispatch(
      DocumentGroupServices.allDocumentGroups(currentUser?.customerId, apiToken)
    );
    const success: any = "download";
    notifySuccess(allDocumentsGroup, success);
    setReload(false);
  };
  const setReloadTable = () => {
    setReload(true);
  };
  let userPth = {
    id: users?.id,
    documents: "document",
  };
  return (
    <div className="UploadDocument-form-page">
      <Container fullWidth>
        <Grid container justifyContent="flex-start">
          <BackButton link={"/ms/administrations/archive"} />
        </Grid>
        <Panel>
          <Grid
            item
            xs={4}
            className={`${classes.marginTop15} uploadDocument-btn`}
          >
            <FileUpload {...fileUploadProp} />
          </Grid>
          <Grid
            container
            spacing={2}
            className={`${classes.marginTop15} uploadDocument-input-field`}
          >
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) => setSelect({ ...select, name: str })}
                placeholder={formatMessage({
                  id: "document.upload.fileName",
                  defaultMessage: "File name",
                })}
                value={select?.name}
                Textlabel="user.edit.name"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setSelect({ ...select, description: str })
                }
                placeholder={formatMessage({
                  id: "document.upload.description",
                  defaultMessage: "Please fill description",
                })}
                value={select?.description}
                Textlabel="group.user.description"
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ paddingRight: "10px" }}
              className="dropdownItemField"
            >
              {/* <SelectDropDown
              nameid="userId"
              handleChange={handleChangeGroup}
              fieldName={"user"}
              selctOption={
                users?.id
                  ? allDocumentGroupMarge
                  : allDocumentGroupMarge?.filter((item) => item?.id != -1)
              }
              selected={selected}
              placeholder={formatMessage({
                id: "group.selectGroup",
                defaultMessage: "Select group",
              })}
              ClassName={classes.GroupSelect}
              Textlabel="group.file"
            /> */}
              <DropDownItem
                data={[...addGroup, ...allDocumentsGroup]}
                restrict={checked}
                handleChange={(val) => {
                  let selecValue = val?.id;
                  if (selecValue == 0) {
                    setOpen(true);
                  } else {
                    setSelect({ ...select, userName: selecValue });
                    setSelected(selecValue);
                    setSelectValue(val);
                  }
                }}
                selectValue={selectValue}
              />
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            className={classes.marginTop15}
          >
            <ButtonSubmit text={"model.title.cancel"} onClick={cancelButton} />
            {users?.id ? (
              <ButtonSubmit text={"document.upload"} onClick={updateDocument} />
            ) : (
              <ButtonSubmit text={"document.upload"} onClick={fileUpload} />
            )}
          </Grid>
          <CreateDocument
            handleClose={closeBox}
            open={open}
            group={undefined}
            documentData={userPth}
            forceReload={reloadTable}
            setReload={setReloadTable}
            hierarchicalDocumentFunction={() => hierarchicalDocumentFunction()}
            data={treeStructureDocument}
          />
        </Panel>
      </Container>
    </div>
  );
};
